import React from 'react';
import Section from './Section';

const groups = [
    { label: 'LLM / AI', items: 'Agentic RAG, LangChain, LangGraph, LLM-as-judge, prompt design' },
    { label: 'Languages', items: 'Java, Python, TypeScript, JavaScript' },
    { label: 'Backend', items: 'Spring Boot, Node.js, Express, Dropwizard, FastAPI' },
    { label: 'Data & messaging', items: 'MongoDB, MySQL, Redis, Aerospike, Elasticsearch, Kafka' },
    { label: 'Infra', items: 'Docker, Kubernetes, Azure DevOps' },
];

export default function Skills() {
    return (
        <Section id="skills" title="Skills">
            {groups.map((g) => (
                <p key={g.label}>
                    <strong>{g.label}.</strong> {g.items}.
                </p>
            ))}
        </Section>
    );
}
